import React from "react";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface CloseButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onClose: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onClose,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="close-button"
      testId="close"
      variant="outlined"
      startIcon={<ContentPasteGoIcon />}
      onClick={onClose}
    />
  );
};
export default CloseButton;
